import MessageIcon from '@mui/icons-material/Message';
import { useOrderAdjustmentIndex } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentIndex';
import { OrderAdjustmentsFormValues } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentsForm';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Identifier } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { ContextMenuButton } from 'shared/mui/ContextMenu';

type Props = {
  onClick: VoidFunction;
  orderId: Identifier;
};

export const OrderAdjustmentsCommentButton: React.FC<Props> = ({ onClick, orderId }) => {
  const translate = useTypedTranslate();
  const { watch } = useFormContext<OrderAdjustmentsFormValues>();
  const recordIndex = useOrderAdjustmentIndex(orderId);
  const comment = watch(`orderAdjustments.${recordIndex}.comment`);

  return (
    <ContextMenuButton
      icon={<MessageIcon color={comment ? 'primary' : 'secondary'} />}
      label={translate('app.orderAdjustments.contextMenu.comment')}
      onClick={onClick}
    />
  );
};
